export function mixColors(colors: number[]): number {
  if (colors.length === 0) return 0xffffff
  let r = 0, g = 0, b = 0
  for (const c of colors) {
    r += (c >> 16) & 0xff
    g += (c >> 8) & 0xff
    b += c & 0xff
  }
  const n = colors.length
  r = Math.round(r / n)
  g = Math.round(g / n)
  b = Math.round(b / n)
  return (r << 16) | (g << 8) | b
}

export function blendColors(c1: number, w1: number, c2: number, w2: number): number {
  const total = w1 + w2
  if (total <= 0) return c1
  const r1 = (c1 >> 16) & 0xff, g1 = (c1 >> 8) & 0xff, b1 = c1 & 0xff
  const r2 = (c2 >> 16) & 0xff, g2 = (c2 >> 8) & 0xff, b2 = c2 & 0xff
  const r = Math.round((r1 * w1 + r2 * w2) / total)
  const g = Math.round((g1 * w1 + g2 * w2) / total)
  const b = Math.round((b1 * w1 + b2 * w2) / total)
  return (r << 16) | (g << 8) | b
}
